export const autoAppliedCoupon = 'auto_applied_coupon';
